import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import images from "../../images";

import { useSwipeable } from "react-swipeable";
// import stepOnboard from "../../contanst/stepOnboard.json";
import { useTranslation, Trans } from "react-i18next";
import { useUpdateUserInfoMutation } from "../../services/apiSlice";

const OnboardingSteps = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [activeStep, setActiveStep] = useState(1);
  const questId = searchParams.get("quest_id");
  const locationId = searchParams.get("location_id");
  const [updateUserInfo, { isLoading }] = useUpdateUserInfoMutation();
  const [formData, setFormData] = useState({
    age: "",
    gender: "",
  });
  const [errors, setErrors] = useState({
    age: "",
    gender: "",
  });

  const stepOnboard = [
    {
      title: (
        <Trans i18nKey="onBoard.earn100Coins">
          <img
            src={images.RallyCoins}
            alt="coins"
            className="inline-block w-[30px] h-[30px] mb-[6px]"
          />
        </Trans>
      ),
      description: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("onBoard.getCashbackInExchange"),
          }}
        />
      ),
      image: images.StartPage1,
    },
    {
      title: t("onBoard.levelUpXPForMoreCash"),
      description: t("onBoard.collectXPByCompleting"),
      image: images.StartPage2,
    },
    {
      title: t("onBoard.questMadeForYou"),
      description: t("onBoard.shareYourInfo"),
      inputs: [
        {
          id: "age",
          placeholder: t("onBoard.age"),
          type: "number",
          icon: images.CalendarIcon2,
        },
        {
          id: "gender",
          placeholder: t("onBoard.gender"),
          type: "select",
          icon: images.User3Icon,
          options: [
            { value: "", label: t("signUp.gender.gender") },
            { value: "male", label: t("signUp.gender.male") },
            { value: "female", label: t("signUp.gender.female") },
            {
              value: "maleIdentifying",
              label: t("signUp.gender.maleIdentifying"),
            },
            {
              value: "femaleIdentifying",
              label: t("signUp.gender.femaleIdentifying"),
            },
            { value: "nonBinary", label: t("signUp.gender.nonBinary") },
            { value: "agender", label: t("signUp.gender.agender") },
            {
              value: "preferNotToSay",
              label: t("signUp.gender.preferNotToSay"),
            },
          ],
        },
      ],
      buttonText: t("onBoard.letsGo"),
    },
  ];

  useEffect(() => {
    if (activeStep > stepOnboard.length) {
      if (locationId !== ("null" || null)) {
        navigate(`/quest/location/${locationId}`);
      } else {
        navigate(
          questId && questId !== "null" ? `/quest/details/${questId}` : "/"
        );
      }
    }
  }, [activeStep, navigate, questId, locationId, stepOnboard.length]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };
  const CustomSelect = ({ options, value, onChange, placeholder, icon }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    const handleSelect = (optionValue) => {
      onChange(optionValue);
      setIsOpen(false);
    };

    const selectedOption = options.find((opt) => opt.value === value);

    return (
      <div className="relative w-full" ref={selectRef}>
        {/* Select Button */}
        <div
          className="flex items-center justify-between  w-full rounded-lg  cursor-pointer  px-4 py-1 text-base"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span
            className={`flex-1 text-base ${
              !value ? "text-gray-400" : "text-black"
            }`}
          >
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <img src={images.ChevronDownIcon} alt="" className="w-5 h-5" />
        </div>

        {/* Dropdown Options */}
        {isOpen && (
          <div className="absolute top-full left-0 right-0 z-50 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto mt-1">
            {options.map((option) => (
              <div
                key={option.value}
                className={`px-4 py-3 cursor-pointer hover:bg-gray-100 transition-colors ${
                  option.value === value
                    ? "bg-blue-50 text-blue-600"
                    : "text-gray-700"
                }`}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };
  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.age || formData.age.trim() === "") {
      newErrors.age = t("onBoard.ageRequired") || "Age is required";
    } else if (parseInt(formData.age) < 13 || parseInt(formData.age) > 120) {
      newErrors.age = t("onBoard.ageInvalid");
    }

    if (!formData.gender || formData.gender === "") {
      newErrors.gender = t("onBoard.genderRequired");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (activeStep === 3) {
      if (!validateForm()) {
        return;
      }

      try {
        const userData = {
          age: parseInt(formData.age),
          gender: formData.gender,
        };

        await updateUserInfo(userData).unwrap();
        if (locationId !== ("null" || null)) {
          navigate(`/quest/location/${locationId}`);
        } else {
          navigate(
            questId && questId !== "null" ? `/quest/details/${questId}` : "/"
          );
        }
      } catch (error) {
        console.error("Error updating user info:", error);
      }
    } else {
      if (activeStep >= stepOnboard.length) {
        if (locationId !== ("null" || null)) {
          navigate(`/quest/location/${locationId}`);
        } else {
          navigate(
            questId && questId !== "null" ? `/quest/details/${questId}` : "/"
          );
        }
      } else {
        setActiveStep((prev) => prev + 1);
      }
    }
  };

  const handlePrev = () => {
    if (activeStep > 1) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (activeStep < stepOnboard.length) {
        setActiveStep((prev) => prev + 1);
      }
    },
    onSwipedRight: () => {
      if (activeStep > 1) {
        setActiveStep((prev) => prev - 1);
      }
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const NavigationButtons = ({ activeStep, onNext, onPrev }) => (
    <div className="flex items-center justify-center gap-6">
      {/* Previous Button */}
      {/* <button
        onClick={onPrev}
        disabled={activeStep === 1}
        className={`w-12 h-12  flex items-center justify-center transition-all duration-300 ${
          activeStep === 1 ? "cursor-not-allowed" : ""
        }`}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          className={activeStep === 1 ? "text-gray-300" : "text-[#253FF6]"}
        >
          <path
            d="M15 18L9 12L15 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button> */}

      {activeStep !== 3 && (
        <button
          onClick={onNext}
          disabled={activeStep === stepOnboard.length && activeStep !== 3}
          className={`w-9 h-12  flex items-center justify-center transition-all duration-300 ${
            activeStep === stepOnboard.length && activeStep !== 3
              ? "cursor-not-allowed"
              : ""
          }`}
        >
          <img src={images.ArrowRightIconBlue} alt="" />
        </button>
      )}
    </div>
  );
  // const StepIndicator = ({ activeStep }) => (
  //   <div className="flex gap-1  justify-center">
  //     {stepOnboard.map((_, index) => (
  //       <div
  //         key={index}
  //         className={`h-[5px] rounded-xl transition-all duration-300 cursor-pointer ${
  //           activeStep === index + 1 ? "bg-[#253FF6]" : "bg-stone-200"
  //         }`}
  //         style={{ width: activeStep === index + 1 ? "24px" : "14px" }}
  //         onClick={() => setActiveStep(index + 1)}
  //       />
  //     ))}
  //   </div>
  // );

  return (
    <main
      {...swipeHandlers}
      className="flex flex-col mx-auto w-full max-w-[480px] h-full bg-white px-[25px]  "
    >
      <Helmet>
        <meta name="theme-color" content="#fefce8" />
      </Helmet>

      <div className="flex flex-col flex-1 h-[710px] mt-[100px] gap-[60px] ">
        <section className="flex w-full   ">
          <img
            src={images.LogoLogin}
            className="w-[80px] h-[60px] aspect-[4/3] "
            alt="Logo"
          />
        </section>

        <section className="flex flex-col  flex-1  gap-[60px]  ">
          <div className="flex flex-col gap-[18px]">
            <h1 className="  text-[#253FF6] text-4xl leading-[2.5rem] font-bold whitespace-pre-line ">
              {stepOnboard[activeStep - 1]?.title}
            </h1>
            <p className="text-xl font-medium text-[#253FF6] whitespace-pre-line ">
              {stepOnboard[activeStep - 1]?.description}
            </p>
          </div>

          {activeStep === 3 ? (
            <div className="flex flex-col gap-4">
              {stepOnboard[2]?.inputs.map((input) => (
                <div key={input.id} className="flex flex-col">
                  <div className="flex items-center border border-gray-300 rounded-lg px-4 py-3">
                    <img src={input.icon} alt="Icon" className="w-5 h-5 mr-3" />
                    {input.type === "select" ? (
                      <CustomSelect
                        options={input.options}
                        value={formData[input.id]}
                        onChange={(value) => handleInputChange(input.id, value)}
                        placeholder={input.placeholder}
                        icon={input.icon}
                      />
                    ) : (
                      <input
                        id={input.id}
                        type={input.type}
                        placeholder={input.placeholder}
                        value={formData[input.id]}
                        onChange={(e) =>
                          handleInputChange(input.id, e.target.value)
                        }
                        className="w-full px-4 py-1 text-base focus:outline-none focus:border-transparent"
                        min={input.type === "number" ? "13" : undefined}
                        max={input.type === "number" ? "120" : undefined}
                      />
                    )}
                  </div>

                  {errors[input.id] && (
                    <p className="text-red-500 text-sm mt-1 ml-1">
                      {errors[input.id]}
                    </p>
                  )}
                </div>
              ))}

              <button
                className={`w-full px-4 py-3 text-white rounded-lg text-lg font-medium transition-all ${
                  isLoading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#253FF6] hover:bg-[#1e32cc]"
                }`}
                onClick={handleNext}
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="flex items-center justify-center gap-2">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    {t("base.loading")}
                  </div>
                ) : (
                  stepOnboard[2]?.buttonText
                )}
              </button>
            </div>
          ) : (
            <figure className="flex justify-center items-center w-full">
              <img
                loading="lazy"
                src={stepOnboard[activeStep - 1]?.image}
                className={`object-contain max-w-[300px] aspect-[1.75]  ${
                  activeStep === 1
                    ? "w-[221.62px] h-[300px]"
                    : "w-[266.58px] h-[275px]"
                }`}
                alt="Step illustration"
              />
            </figure>
          )}

          {/* <div className="w-full max-w-[400px]">
            <StepIndicator
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          </div> */}
        </section>
        <div className="w-full   max-w-[400px] flex justify-end items-center ">
          <NavigationButtons
            activeStep={activeStep}
            onNext={handleNext}
            onPrev={handlePrev}
          />
        </div>
      </div>
    </main>
  );
};

export default OnboardingSteps;
